<template>
  <main-layout>
    <b-loading :is-full-page="true" :active.sync="loading" />
    <!-- <div style="padding-bottom:15px;">Modifica {{ customer.name }}</div> -->
    <div v-if="!loading">
      <customer-form :item="customer" :fields="fields" />
      <contacts-form
        :customer-id="customer.id"
        :contacts="contacts"
        :active-support-contracts-count="customer.active_support_contracts"
        @generateEmail="generateEmail"
      />
      <product-contracts-form
        :customer-id="customer.id"
        :product-contracts="productContracts"
      />
      <support-contracts-form
        :customer-id="customer.id"
        :support-contracts="supportContracts"
        :product-contracts="productContracts"
      />
      <course-contracts-form
        :customer-id="customer.id"
        :course-contracts="courseContracts"
      />
      <marketing-form
        :customer-id="customer.id"
        :marketing-actions="marketingActions"
      />

      <b-collapse v-if="estimates.results.length > 0" class="panel">
        <div slot="trigger" class="panel-heading" style="font-size: 14px">
          <strong>Preventivi</strong>
        </div>
        <div class="panel-block">
          <table class="table is-fullwidth is-narrow">
            <!-- <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Data</th>
              </tr>
            </thead>-->
            <tbody style="font-size: 14px">
              <tr v-for="estimate in estimates.results" :key="estimate.id">
                <td>
                  <b>
                    <router-link
                      :to="{
                        name: 'estimates.show',
                        params: { id: estimate.id }
                      }"
                    >
                      {{ estimate.id }}
                    </router-link>
                  </b>
                </td>
                <td>
                  <b>
                    <router-link
                      :to="{
                        name: 'estimates.show',
                        params: { id: estimate.id }
                      }"
                    >
                      {{ estimate.name }}
                    </router-link>
                  </b>
                </td>
                <td width="150">{{ estimate.date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-collapse>
    </div>
  </main-layout>
</template>

<script>
import { get, call } from "vuex-pathify"
import store from "@/store"

import CustomerForm from "@/components/CustomerForm.vue"
import ContactsForm from "@/components/ContactsForm.vue"
import SupportContractsForm from "@/components/SupportContractsForm.vue"
import ProductContractsForm from "@/components/ProductContractsForm.vue"
import CourseContractsForm from "@/components/CourseContractsForm.vue"
import MarketingForm from "@/components/MarketingForm.vue"
import MainLayout from "@/layouts/Main.vue"
import { fields, showFields } from "./fields"
import cdaEmail from "./cdaEmail"
import fwEmail from "./fwEmail"

export default {
  components: {
    ContactsForm,
    SupportContractsForm,
    ProductContractsForm,
    CourseContractsForm,
    CustomerForm,
    MarketingForm,
    MainLayout
  },
  data() {
    return {
      showFields,
      fields,
      loading: true
    }
  },
  computed: {
    customer: get("customers/customer"),
    contacts: get("contacts/contacts"),
    estimates: get("estimates/estimates"),
    supportContracts: get("supportContracts/supportContracts"),
    productContracts: get("productContracts/productContracts"),
    courseContracts: get("courseContracts/courseContracts"),
    marketingActions: get("marketingActions/marketingActions")
  },
  async beforeRouteUpdate(to, from, next) {
    this.loading = true
    await this.fetchCustomer(to.params.id)
    await this.fetchContacts(to.params.id)
    await this.fetchEstimates({ customer: to.params.id })
    await this.fetchSupportContracts(to.params.id)
    await this.fetchProductContracts(to.params.id)
    await this.fetchCourseContracts(to.params.id)
    await this.fetchMarketingActions(to.params.id)
    this.loading = false
    next()
  },
  beforeDestroy() {
    store.set("customers/customer", {})
    store.set("contacts/contacts", [])
    store.set("estimates/estimates", [])
    store.set("supportContracts/supportContracts", [])
    store.set("productContracts/productContracts", [])
    store.set("courseContracts/courseContracts", [])
    store.set("marketingActions/marketingActions", [])
  },
  async mounted() {
    this.loading = true
    await Promise.all([
      this.fetchCustomer(this.$route.params.id),
      this.fetchContacts(this.$route.params.id),
      this.fetchEstimates({ customer: this.$route.params.id }),
      this.fetchSupportContracts(this.$route.params.id),
      this.fetchProductContracts(this.$route.params.id),
      this.fetchCourseContracts(this.$route.params.id),
      this.fetchMarketingActions(this.$route.params.id)
    ])
    this.loading = false
  },
  methods: {
    fetchCustomer: call("customers/find"),
    fetchContacts: call("contacts/all"),
    fetchEstimates: call("estimates/all"),
    fetchProductContracts: call("productContracts/all"),
    fetchSupportContracts: call("supportContracts/all"),
    fetchCourseContracts: call("courseContracts/all"),
    fetchMarketingActions: call("marketingActions/all"),
    generateEmail(contact, n) {
      let contracts = this.supportContracts.filter(contract => {
        return this.$moment(contract.end_date).isBetween(
          this.$moment().subtract(30, "days"),
          this.$moment().add(90, "days")
        )
      })

      let cdaContracts = contracts.filter(contract => contract.type_category === "CdA")
      let fwContracts = contracts.filter(contract => contract.type_category === "FW")

      let body = ""

      if (fwContracts.length > 0) {
        body += fwEmail(contact, fwContracts, this.productContracts, this.$moment, n)
      } else {
        body += cdaEmail(contact, cdaContracts, this.productContracts, this.$moment, n)
      }

      let link = [
        `mailto:${contact.email}`,
        `?subject=${encodeURI(
          "Rinnovo contratto di assistenza e aggiornamento"
        )}`,
        `&body=${encodeURI(body)}`
      ].join("")
      // console.log(link)
      window.location = link
    }
  }
}
</script>

<style lang="sass" scoped>
nav
  margin-top: 2.1rem
.column.is-narrow:first-child
  padding-left: 0
</style>
